var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-filter--select"},[_c('CSelect',{attrs:{"label":_vm.label,"value":_vm.value,"options":_vm.options},on:{"update:value":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }